import React from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const Home = () => {
  return (
    <div className="bg-black h-screen ">
    <div className="bg-black  justify-content h-screen ">
      <div
        className="bg-cover bg-center h-screen m-auto flex  justify-center  items-center    "
        style={{
          backgroundImage:
            'url("https://wallup.net/wp-content/uploads/2018/10/09/20426-black-dark-cars-ferrari-vehicles-ferrari-f430-black-background-black-cars-front-view-side-view.jpg")',
        }}
      >
        <div>
          <h4 className="text-center  text-white  font-bold text-4xl">
          <a href="/" className="">ESTA OCURRIENDO</a></h4>
           <h4 className="text-center text-white mt-8  hover:underline">PARA SABER MAS <ArrowForwardIosIcon className="hover:text-red-700"/></h4>
        </div>
        
          
        

       
      </div>
    </div>
  </div>
  )
}

export default Home